import { useClient } from "@adamlip/okeoke.client"
import FormattedNumber from "components/FormattedNumber"

export default function MenuItem({ item }) {
  const { getName } = useClient()

  return (
    <div className={`${item?.availability?.visible ? "" : "text-red-600"}`}>
      <div className="">
        {item.count} {getName(item.name)} <FormattedNumber value={item.price} />
      </div>
      {item.modifiers
        ?.filter((modifier) => modifier.count > 0)
        .map((modifier) => (
          <div key={modifier.orderModifierUUID} className="pl-2">
            {modifier.count} {getName(modifier.name)}
          </div>
        ))}
    </div>
  )
}
